/** @jsx jsx */
import styled from '@emotion/styled'

interface Props {
  variant?: 'formDivider'
}

const HR = styled.hr<Props>(
  (props) => ({
    borderTop: 'none',
    borderBottom: `1px solid ${props.theme.colors.iconGray}`,
    margin: '1em 0em',
  }),
  ({ variant }) => variant === 'formDivider' && { margin: '2em 0em' }
)

export default HR
